import { defineStore } from 'pinia'

const storeKey = 'chartRange'

export const useChartConfigStore = defineStore(storeKey, {
  state: () => ({
    loading: true,
  }),

  actions: {
    startLoad() {
      this.loading = true
    },
    endLoad() {
      this.loading = false
    },
  },
})
